import { createSlice } from "@reduxjs/toolkit";

const CommonInformationDialogInitialState = {
  dialogHeader: "",
  dialogText: "",
  dialogOpen: false
};

const CommonInformationDialogReduer = createSlice({
  name: "commonInfoDialogReduer",
  initialState: CommonInformationDialogInitialState,
  reducers: {
    updateDialogHeader(state, action) {
      state.dialogHeader = action.payload;
    },
    updateDialogText(state, action) {
      state.dialogText = action.payload;
    },
    updateDialogOpen(state, action) {
      state.dialogOpen = action.payload;
    },
    resetDialog(state) {
      state.dialogHeader = "";
      state.dialogText = "";
      state.dialogOpen = false;
    },
  },
});
export const CommonInformationDialogReduerAction = CommonInformationDialogReduer.actions;
export default CommonInformationDialogReduer.reducer;
